import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { returnPathOf } from "../features/auth/expiry";

/** The pages of a person who is not signed in; a signed-in person goes home, or back to the page an expired session
 * left. */
export const Route = createFileRoute("/_public")({
  beforeLoad: ({ context, location }) => {
    if (context.session.status === "signedIn") {
      const back = returnPathOf(location.search);
      throw back === undefined ? redirect({ to: "/" }) : redirect({ href: back });
    }
  },
  component: Outlet,
});
